module.exports = __webpack_public_path__ + "img/hakuna_media.5049b55a.jpg";